import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/path-black.svg'


const _withScopeId = n => (_pushScopeId("data-v-1ecbe36b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full h-[100px] total-balance flex flex-col items-start px-8 py-3" }
const _hoisted_2 = { class: "grid grid-cols-2 w-full" }
const _hoisted_3 = { class: "col-span-1 flex flex-col items-start justify-start" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-white text-[12px]" }, "N° de Acciones B", -1))
const _hoisted_5 = { class: "font-bold text-[28px] text-center text-white" }
const _hoisted_6 = { class: "text-[12px] text-white" }
const _hoisted_7 = {
  key: 1,
  class: "text-white text-[12px]"
}
const _hoisted_8 = { class: "w-full h-[50px] total-balance view-movement flex items-center justify-center gap-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-black text-[12px]" }, "Ver movimientos", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "",
  src: _imports_0,
  alt: ""
}, null, -1))

import { ref, onMounted, computed } from "vue";
import { ShareholderService } from "@/services/shareholder/ShareholderService";
import { shareholderStore } from "@/stores/shareholder";
import { accountStore } from "@/stores/account";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionsCount',
  props: {
  shareholders: {
    type: Number || null,
  },
  shares: {
    type: Number || null,
  },
},
  setup(__props) {



const shareholderStr = shareholderStore();
const shareholder = computed(() => shareholderStr.shareholder);
const dividendClp = ref();

const accountStr = accountStore();
const activeAccount = computed(() => accountStr.activeAccount);

onMounted(async () => {
  try {
    const shareholderService = new ShareholderService();
    const response = await shareholderService.getShareholderDetail(
      shareholder.value.id
    );

    if (response.success) {
      dividendClp.value = response.data.dividendBalanceClp.toString();
    }
  } catch (error) {
    console.error(error);
  }
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_unref(activeAccount) != 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_4,
                _createElementVNode("p", _hoisted_5, _toDisplayString(__props.shares ?? _unref(accountStr).accountSelected?.totalSharesB), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString("Accionista: " +
              (_unref(accountStr).accountSelected?.investorNumberB ?? "-")), 1)
              ], 64))
            : (_openBlock(), _createElementBlock("h1", _hoisted_7, " Seleccione una cuenta para ver más información "))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_router_link, {
        class: "btn-solicitud",
        "active-class": "font-bold text-green-700",
        to: { name: 'MyMovements' }
      }, {
        default: _withCtx(() => [
          _hoisted_9,
          _hoisted_10
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})